require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./front-end-libraries-front-end-libraries-projects-build-a-javascript-calculator.json") })
        }
      }, "path---front-end-libraries-front-end-libraries-projects-build-a-javascript-calculator");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---front-end-libraries-front-end-libraries-projects-build-a-javascript-calculator!./.cache/json/front-end-libraries-front-end-libraries-projects-build-a-javascript-calculator.json
// module id = 2028
// module chunks = 231608221292675